module.exports = __webpack_public_path__ + "static/fonts/DMSans-Medium.b63df967.woff2";